import styled from 'styled-components'
import { colors } from '../../theme'

export const ButtonDownload = styled.button`
  padding: 8px 30px;
  border-radius: 12px;
  background-color: ${colors.surfaceHigh};
  border: none;
  text-decoration: none;
  cursor: pointer;
`

export const LinkDownload = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  color: ${colors.white};
`
